import { Box, Button, Container, Divider, InputAdornment, Stack, TextField, Typography } from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';
import Layout from "./Layout";
import theme from "./Theme";
import { router, Link } from "@inertiajs/react";
import { useEffect, useState } from "react";

export interface SupportArticles {
  administrators: SupportArticle[];
  practitioners: SupportArticle[];
  managers: SupportArticle[];
}
export interface SupportArticle {
  id: string;
  title: string;
  content: string;
  category: string;
  published: boolean;
}

function SupportSection({name, articles}: {name: string, articles: SupportArticle[]}) {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', flex: 1, p: 2}}>
      <Typography py={2} variant="h6" fontWeight={670}>{name}</Typography>
      <Stack gap={3}>
        {articles.map((article) => (
          <Link href={`/support/${article.id}`} key={article.id} style={{ textDecoration: 'none', color: theme.palette.primary.main }}>
            <Typography variant="body1">{article.title}</Typography>
          </Link>
        ))}
      </Stack>
      <Button 
        onClick={() => { router.visit(`/support/?category=${name.toLowerCase()}`)}}
        variant="outlined"
        sx={{ width: '116px', color: theme.palette.primary.main, mt: 3, fontWeight: 570 }}
      >
        VIEW ALL
      </Button>
    </Box>
  )
}

export default function Support(supportArticles: SupportArticles) {
  const [search, setSearch] = useState('');
  const [filteredArticles, setFilteredArticles] = useState(supportArticles);

  useEffect(() => {
    setFilteredArticles({
      administrators: supportArticles.administrators.filter((article) => article.title.includes(search)),
      practitioners: supportArticles.practitioners.filter((article) => article.title.includes(search)),
      managers: supportArticles.managers.filter((article) => article.title.includes(search)),
    });
  }, [search]);

  return (
    <Layout title="Support">
      <Container>
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', p: 3, mt: 9, width: '100%'}}>
          <Typography sx={{ color: theme.pandia.indigo_dark, fontWeight: 790 }} variant="h2">Support & helpful topics</Typography>
          <Typography sx={{ fontWeight: 400 }} variant="h5">All your how to's and support needs</Typography>
          <TextField 
            placeholder="Search support" 
            onChange={(e) => setSearch(e.target.value)}
            variant="outlined" 
            slotProps={{
              input: {
                startAdornment: <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              }
            }}
            sx={{ mt: 3, width: '100%', maxWidth: '762px' }}
          />
          <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', p: 3, mt: 6, maxWidth: '900px', width: '100%'}}>
            <SupportSection name="Practitioners" articles={filteredArticles.practitioners.slice(0, 3)} />
            <Divider orientation="vertical" flexItem />
            <SupportSection name="Managers" articles={filteredArticles.managers.slice(0, 3)} />
            <Divider orientation="vertical" flexItem />
            <SupportSection name="Administrators" articles={filteredArticles.administrators.slice(0, 3)} />
          </Box>
        </Box>
      </Container>
    </Layout>
  )
}